import React from 'react'
import { resolveComponentForOperator } from 'components/ContactFilterBuilder/constants/PropertyComponents'

const IsNot = ({ property, onChange, value }) => {  

  const PropertyComponent = resolveComponentForOperator(property.type, 'IS_NOT')

  return (
    <div>
      <PropertyComponent
        property={property}
        onChange={onChange}
        value={value}
        isOperator={true}
      />
    </div>
  )
}

export default IsNot
